// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table__row{cursor:pointer}.el-pagination.is-background .el-pager li:not(.disabled).active{background-color:#568156;border-color:#568156}", ""]);
// Exports
module.exports = exports;
